@if (!isUiTest) {
  <div class="account-history-container">
    <div class="portfolio-history-header-block left">Attributes of this account have been edited as noted below:
    </div>
    <div class="right export-action">
      <span class="right">
        <fa-icon id="exportLink" [icon]="faDownload" (click)="exportHistory()" class="irb-green clickable" tooltip
        [tooltipTitle]="'Export'"></fa-icon>
      </span>
    </div>
    <div class="account-history-grid">
      <irb-inventory-grid
        [style.width]="'100%'"
        [style.height]="'100%'"
        [showSideBar]="false"
        [gridOptions]="gridOptions"
        [frameworkComponents]={}
      (gridReady)="onGridReady($event)"></irb-inventory-grid>
    </div>
  </div>
}
